import { useLanguage } from "@/components/LanguageContext";
import { Reveal } from "@/components/Reveal";

const StatsBand = () => {
  const { t } = useLanguage();
  return (
    <section data-testid="stats-band" className="bg-navy py-16 text-bone lg:py-20">
      <div className="mx-auto grid max-w-[1440px] grid-cols-1 gap-12 px-6 lg:grid-cols-12 lg:px-16">
        <div className="grid grid-cols-2 gap-x-8 gap-y-10 lg:col-span-8 lg:grid-cols-4">
          {t.stats.items.map((s, i) => (
            <Reveal key={s.l} delay={i * 0.07}>
              <div data-testid={`stat-${i + 1}`} className="border-l border-gold/40 pl-5">
                <p className="font-display text-5xl font-medium text-gold lg:text-6xl">{s.n}</p>
                <p className="mt-2 font-mono text-[11px] uppercase tracking-[0.2em] text-bone/70">{s.l}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.2} className="lg:col-span-4">
          <blockquote
            data-testid="stats-quote"
            className="flex h-full flex-col justify-center border-l border-bone/15 pl-6 font-display text-2xl italic leading-snug text-bone/90 lg:text-3xl"
          >
            {t.stats.quote}
            <footer className="mt-4 font-mono text-[11px] not-italic uppercase tracking-[0.2em] text-gold">
              {t.stats.author}
            </footer>
          </blockquote>
        </Reveal>
      </div>
    </section>
  );
};

export default StatsBand;
